import { render, staticRenderFns } from "./TheDrawer.vue?vue&type=template&id=1f0af19e&scoped=true"
import script from "./TheDrawer.vue?vue&type=script&lang=js"
export * from "./TheDrawer.vue?vue&type=script&lang=js"
import style0 from "./TheDrawer.vue?vue&type=style&index=0&id=1f0af19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0af19e",
  null
  
)

export default component.exports